var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper test"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row login-white-wrap whiteBG-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [_c(_vm.currentComponent, {
    key: _vm.$route.path,
    tag: "component"
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding"
  }, [_c('LoginCarsoule')], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }